import { ToastContainer, toast } from 'react-toastify';

import loading from "../../../assets/images/loading.gif"
import { useState, useEffect, FormEvent } from "react";
import { makeGetRequest, makePatchRequest } from "../../../request";
import { useSelector } from "react-redux";
import { customStyles, getShipmentStatusIndex, ShipmentStatus } from "../../../helpers";
import Pagination from "../../../components/Pagination";
import Layout from '../../Layout';
import Modal from "react-modal"
import { Link, useLocation, useNavigate } from 'react-router-dom';


import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';

const ShippingDocuments =  () => {
    const navigate = useNavigate()
    const user:any = useSelector((state: any) => state.tepngUser.value);
    const location = useLocation()
    const statusBeforeNavigation = location.state as { status: number };
    const [shippingDocuments, setRecords] = useState<Record <string, any>>([])    
    const [isConfirmModal, setIsConfirmModal] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [formData, setFormData] = useState({
        shippingDocumentId: "",    
        signedDeliveryDocument: "",
        rowVersion: ""
    })
    
    const clearData = () => {
        setFormData({
            shippingDocumentId: "",    
            signedDeliveryDocument: "",
            rowVersion: ""
        })
    }

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const totalPages = Math.ceil(totalItems / itemsPerPage);  
    const [startIndex, setStartIndex] = useState(0);
    const getPageNumbers = () => {
        return Array.from({ length: totalPages }, (_, i) => i + 1);
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
            if (currentPage >= startIndex + 4) {
                setStartIndex(startIndex + 4);
            }
        }
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
            if (currentPage - 1 <= startIndex) {
                setStartIndex(startIndex - 4);
            }
        }
    };
    
    const [searchValue, setSearchValue] = useState("")
    const [status, setStatus] = useState<number|null>(statusBeforeNavigation?.status ? statusBeforeNavigation.status : 1)
    const handleSearch = (event: any) => {
        const value = event.target.value
        if(!value) setSearchValue("")
    }

    const handleFileChange = (event: any) => {
        const { name, files } = event.target;
        let selectedFile = files[0];
    
        let file = selectedFile.name.split(".");
        const fileFormat = file ? file[file.length - 1] : "";
        
        // Define allowed formats
        const allowedFormats = ["zip", "pdf"];
        const maxFileSize = 10 * 1024 * 1024; // 10 MB in bytes
        
        if (allowedFormats.includes(fileFormat.toLowerCase())) {
            if (selectedFile.size <= maxFileSize) {
                // File is within size limit
                setFormData({...formData, [name]: selectedFile}) 
            } else {
                // File exceeds size limit
                toast.error("File size exceeds 5 MB. Please upload a smaller file.");
                const element = event.target as HTMLInputElement;
                element.value = ""; // Clear the file input
            }
        } else {
            // Invalid file format
            if (fileFormat) {
                toast.error(
                    "Attempted to upload an invalid file format. Please re-upload with a valid format (zip, pdf)."
                );
            }
            const element = event.target as HTMLInputElement;
            element.value = ""; // Clear the file input
        }
    };

    const [isLoading, setIsLoading] = useState(false)
    const getShippingDocuments = () => {
        setIsLoading(true)
        
        var request: Record<string, any> = {
            what: "getShippingDocumentsForPortOfficer",
            params: {
                Page: currentPage,
                PageSize: itemsPerPage,
                OrderBy: 2,
                PortOfficerId: user?.id
            },
        };
        if(searchValue) {request.params.SearchString = searchValue; setStatus(null);}

        let statusName = ""
        switch (status) {
            case 1:
                statusName = "Port Officer Desk,Awaiting Custom Duty Payment,LCA Completed Upload"
                break;

            case 2:
                statusName = "Shipment Delivered"
                break;

            default:
                statusName = "Port Officer Desk,Awaiting Custom Duty Payment,LCA Completed Upload"
                break;
        }
        if(status) request.params.status = statusName
        
        makeGetRequest(request)
            .then((response: any) => {
                setIsLoading(false)
                const res = response.data.data
                setRecords(res)
                setTotalItems(response.data.totalCount)
            })
            .catch((error:any) => 
                toast.error(error.errorMessage)
            );
    }
   
    const [selectedRow, setSelectedRow] = useState("")
        const [toggleExpand, setToggleExpand] = useState(false)
        const row = shippingDocuments?.map((data: any, index:number) => {
                        return (
                            <>
                                <tr key={index}>
                                    <td onClick={() => {setSelectedRow(data.id); setToggleExpand(!toggleExpand)}} style={{paddingLeft: "8px", cursor: "pointer", }} 
                                        className="fw-600 text-blue">
                                        <div className="d-flex" style={{textWrap: "nowrap"}}>
                                            {(selectedRow !== data.id || !toggleExpand) && <span className="material-symbols-rounded">expand_more</span>}
                                            {selectedRow === data.id && toggleExpand && <span className="material-symbols-rounded">expand_less</span>}
                                            { currentPage === 1 ? currentPage + index : (((itemsPerPage*currentPage)-itemsPerPage)+1) + index }
                                        </div>
                                    </td>     
                                    <td>{ data.referenceNumber }</td> 
                                    <td>{ data.shippingNumber }</td>
                                    <td>{ data.consolidatedPackingList?.modeOfShipping }</td>
                                    <td>{ data?.consolidatedCommercialInvoice?.purchaseOrderItemSupplies[0]?.currency }</td>
                                    <td>{ data?.consolidatedCommercialInvoice?.consignee }</td>
                                    <td>{ data?.consolidatedCommercialInvoice?.destinationPlant }</td>
                                    <td>
                                        {status === 1 &&
                                        <div className="dropdown">
                                            <button className="dropbtn-2"><span className="material-symbols-outlined" style={{fontSize: "24px"}}>more_horiz</span></button>
                                            <div className="dropdown-content">
                                                <button
                                                    onClick={() => navigate("/portofficer/shippingdocuments/"+data.id, {state: {status: status}})}
                                                    >View Documents</button>

                                                {/* display if the date has been set (i.e. port officer has acknowledged receeption of shipment) */}
                                                {(data?.dateOfReceipt && data?.dateOfTransferToReception) && <button
                                                    onClick={() => navigate("/portofficer/handoffdocument/"+data.id, {state: {status: status}})}
                                                    >Preview Handoff Document</button>} 

                                                {!(data?.dateOfReceipt && data?.dateOfTransferToReception) && 
                                                <button
                                                    onClick={() => navigate("/portofficer/managereceptiondetails/"+data.id, {state: {status: status}})}
                                                    >Manage Reception Details</button>
                                                }

                                                {/* display if the handoff document has been acknowledged */}
                                                {(data?.dateOfReceipt && data?.dateOfTransferToReception) && <button
                                                    disabled={data?.handOffDocument?.portOfficerId === null ? true : false}
                                                    onClick={() => {setIsConfirmModal(true); setFormData({...formData, shippingDocumentId: data.id, rowVersion: data.rowVersion})}}
                                                    >Confirm Delivery</button> }
                                            </div>
                                        </div>}

                                        {status === 2 && <Link to={"/portofficer/shippingdocuments/"+data.id} className="actions">
                                            <span className="material-symbols-rounded">pageview</span>
                                            <span>View Details</span>
                                        </Link>}
                                    </td>                                
                                </tr>
                                {selectedRow === data.id && toggleExpand && 
                                    <>
                                        <td colSpan={12} style={{backgroundColor: "white"}}>                                           

                                            <Box sx={{ width: '95%', margin: "16px 0" }}>
                                                <Stepper activeStep={getShipmentStatusIndex(data.currentStatus)} alternativeLabel>
                                                    {ShipmentStatus().map((label: any, index: number) => {
                                                        const inactiveSteps = [];
                                                        if (data.allDocumentsApprovedByTransit !== true) inactiveSteps.push("LCA Completed Upload");

                                                        if(data.clearingProcessStatuses.find((status: any) => status.toStatus !== "Awaiting Custom Duty Payment")) {
                                                            inactiveSteps.push("Awaiting Custom Duty Payment");
                                                        }

                                                        if(data.clearingProcessStatuses.every((status: any) => status.toStatus !== "Rejected") || data.clearingProcessStatuses.length === 0) {
                                                            inactiveSteps.push("Rejected");
                                                        }
                                                        
                                                        const isInactive = inactiveSteps.includes(label.name);
                                                        const isCompleted = !isInactive && index < getShipmentStatusIndex(data.currentStatus);
                                                        const isActive = getShipmentStatusIndex(data.currentStatus) === index;
                                                        
                                                        return (
                                                            <Step 
                                                                key={index}
                                                                completed={isCompleted}
                                                                active={isActive}
                                                            >
                                                                <StepLabel
                                                                    StepIconProps={{
                                                                        sx: {
                                                                            color: isInactive ? '#b0b0b0' : 
                                                                                isCompleted ? '#4caf50' : 
                                                                                isActive ? '#1976d2' : '#bdbdbd',
                                                                            '& .MuiStepIcon-text': {
                                                                                fill: isInactive ? 'white' : 
                                                                                    isCompleted ? 'white' : 'white'
                                                                            }
                                                                        }
                                                                    }}
                                                                    sx={{
                                                                        '& .MuiStepLabel-label': {
                                                                            textDecoration: isCompleted ? 'none' : 'none',
                                                                        }
                                                                    }}
                                                                >
                                                                    {label.name}
                                                                </StepLabel>
                                                            </Step>
                                                        );
                                                    })}
                                                </Stepper>
                                            </Box>
                                        </td>
                                    </>
                                }
                            </>
                        )                    
                })

    const handleDeliveryAtDestination = (event: FormEvent) => {
        event.preventDefault()
        setIsSubmitting(true)
        const form = new FormData()
        form.append("shippingDocumentId", formData.shippingDocumentId)   
        form.append("portOfficerId", user?.id)
        form.append("rowVersion", formData.rowVersion)
        form.append("signedDeliveryDocument", formData.signedDeliveryDocument)

        var request: Record<string, any> = {
            what: "confirmDeliveryAtDestination",
            data: form
        };
        
        makePatchRequest(request)
            .then((response: any) => {
                toast.success(response.msg)
                setIsSubmitting(false)
                setIsConfirmModal(false)  
                getShippingDocuments()              
            })
            .catch((error:any) => 
                {toast.error(error.msg); setIsSubmitting(false)}
            );
    }

    useEffect(() => {
        getShippingDocuments() // eslint-disable-next-line
    }, [currentPage, itemsPerPage, searchValue, status, user])

    const page = "Shipping Documents"

    return (
        <Layout title={page}>
            <div className="container">
                <div className="main">
                    <h3 className="page_title">{  }</h3>     
                    <div className="main-inner">
                        <div className="main-inner-top">
                            <div className="d-flex">
                                <div className="search-container left-item">
                                    <span className="material-symbols-rounded">search</span>
                                    <input id="search" placeholder="Search Shipping Documents" onKeyUp={handleSearch}  />
                                </div>
                                <button className="custom-button orange left-item ml-2"
                                    onClick={() => {setSearchValue((document.getElementById("search") as HTMLInputElement)?.value); setCurrentPage(1)}}
                                >Search</button>
                            </div>
                            <div className='d-flex' style={{gap: "16px"}}>
                                <div className="d-flex page-filter">
                                    <span style={{fontSize: "12px", color: "#3e3e3e", fontWeight:"500"}}> Filter By </span>
                                    <div className={status === 1 ? "orange active": "orange"} onClick={() => setStatus(1)}>
                                    {status === 1 && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="#175FDC" style={{width: "10px", marginRight: "4px"}}><path d="M173.9 439.4l-166.4-166.4c-10-10-10-26.2 0-36.2l36.2-36.2c10-10 26.2-10 36.2 0L192 312.7 432.1 72.6c10-10 26.2-10 36.2 0l36.2 36.2c10 10 10 26.2 0 36.2l-294.4 294.4c-10 10-26.2 10-36.2 0z"/></svg>}
                                        New Shipment</div>

                                    <div className={status === 2 ? "green active": "green"} onClick={() => setStatus(2)}>
                                    {status === 2 && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="#175FDC" style={{width: "10px", marginRight: "4px"}}><path d="M173.9 439.4l-166.4-166.4c-10-10-10-26.2 0-36.2l36.2-36.2c10-10 26.2-10 36.2 0L192 312.7 432.1 72.6c10-10 26.2-10 36.2 0l36.2 36.2c10 10 10 26.2 0 36.2l-294.4 294.4c-10 10-26.2 10-36.2 0z"/></svg>}
                                        Shipment Delivered</div>
                                </div>
                            </div>
                        </div>                        

                        <div className='table-container custom'>
                            <table>
                                <thead>
                                    <tr className="no-textwrap">
                                        <th>SN</th>
                                        <th>BL/AWB Number</th>
                                        <th>Shipment Number</th>
                                        <th>Shipping Mode</th>
                                        <th>Currency</th>
                                        <th>Consignee</th>
                                        <th>Destination Plant</th>
                                        <th style={{width: "172px"}}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {isLoading ? null : (
                                            shippingDocuments?.length === 0 ? <td className='no-records' colSpan={6}>No Records Found</td>
                                            : row
                                        )
                                    }
                                </tbody>
                            </table>
                            {isLoading ? <div className="loader">
                                        <img src={loading} alt="loading" />
                                        <p>Loading data...</p>
                                    </div> : null}
                        </div>
                        <div className="pagination-container">
                            <Pagination
                                currentPage={currentPage}
                                itemsPerPage={itemsPerPage}
                                totalPages={totalPages}
                                handlePrevious={handlePrevious}
                                handleNext={handleNext}
                                setCurrentPage={setCurrentPage}
                                getPageNumbers={getPageNumbers}
                                setItemsPerPage={setItemsPerPage}
                                startIndex={startIndex} />
                        </div>
                    </div>                 
                </div> 

                <Modal isOpen={isConfirmModal} style={customStyles} className="modal modal-3" ariaHideApp={false}>
                    <div className="modal-header">
                        <h3>Delivery Confirmation</h3>
                        <span className="material-symbols-rounded close"
                            onClick={() => {setIsConfirmModal(false); setIsSubmitting(false); clearData()}}>close</span>
                    </div>
                    <form onSubmit={handleDeliveryAtDestination}>
                    <div className="modal-body">                        
                        <label><span className="errorX mr-2">*</span>Signed Document <span className='blue-text'>(.pdf, .zip)</span></label>
                        <input name="signedDeliveryDocument" type='file' className='mb-2' accept='.zip, .pdf' required onChange={handleFileChange} />
                        
                        <input required type='checkbox' /> <span style={{fontSize: "12px"}}>I, {user?.firstName} {user?.lastName}, confirm that the materials listed in the shipping documents have arrived at their final shipping destination.</span>
                    </div>
                    <div className="modal-footer bt-1">
                        <button type="button" className="custom-button grey-outline"
                            onClick={() => setIsConfirmModal(false)}>Cancel</button>
                        <button type="submit" 
                        disabled={isSubmitting}
                        className="custom-button orange">{isSubmitting ? "Loading..." : "Submit"}</button>
                    </div>
                    </form>
                </Modal>
                <ToastContainer />
            </div>
        </Layout>
    )
}

export default ShippingDocuments